<template>

  <span>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
                 id="profile-tabs" :key="isSmallerScreen">
          <vs-tab @click="onClickTabs(0)" v-if="$canAny(['view-supplier-raw-materials', 'create-edit-supplier-raw-materials'])" icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Raw Materials' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <raw-material-list/>
            </div>
          </vs-tab>
           <vs-tab @click="onClickTabs(1)" v-if="$canAny(['view-raw-material-orders', 'create-edit-raw-material-orders'])" icon-pack="feather" icon="icon-archive" :label="!isSmallerScreen ? 'RM Orders' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <r-m-orders-list/>
            </div>
          </vs-tab>
          <vs-tab @click="onClickTabs(2)" v-if="$canAny(['view-raw-material-use-report'])" icon-pack="feather" icon="icon-pie-chart" :label="!isSmallerScreen ? 'Predicted Use Report' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <report-table/>
            </div>
          </vs-tab>
          <vs-tab @click="onClickTabs(3)" v-if="$canAny(['view-raw-material-use-report'])" icon-pack="feather" icon="icon-bar-chart" :label="!isSmallerScreen ? 'Low Stock Report' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <low-stock-report-table/>
            </div>
          </vs-tab>
          <vs-tab @click="onClickTabs(4)" v-if="$canAny(['view-raw-material-use-report'])" icon-pack="feather" icon="icon-bar-chart" :label="!isSmallerScreen ? 'Slow Stock Report' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <slow-stock-report-table/>
            </div>
          </vs-tab>
          <!-- <vs-tab @click="onClickTabs(5)" v-if="$canAny(['view-raw-material-use-report'])" icon-pack="feather" icon="icon-bar-chart" :label="!isSmallerScreen ? 'Consumption Report' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <consumption-report-table/>
            </div>
          </vs-tab> -->
        </vs-tabs>
      </div>
    </div>
  </span>
</template>

<script>

  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  const CustomerRepository = RepositoryFactory.get('customer');

  import RawMaterialList from "./rm-list/RawMaterialList";
  import RMOrdersList from './rm-orders/RMOrdersList'
  import ReportTable from './predicted-use-report/ReportTable'
  import LowStockReportTable from './low-stock-report/ReportTable.vue'
  import SlowStockReportTable from '@/views/pages/raw-material/slow-stock-report/ReportTable.vue'
  import ConsumptionReportTable from '@/views/pages/raw-material/consumption-report/ReportTable.vue'

  export default {
    name: 'RawMaterialTabView',
    components: {
      RawMaterialList,
      RMOrdersList,
      ReportTable,
      LowStockReportTable,
      SlowStockReportTable,
      ConsumptionReportTable
    },
    data() {
      return {
        active_step: this.$route.query.step ? this.$route.query.step : '0'
      }
    },
    computed: {
      isSmallerScreen() {
        return this.$store.state.windowWidth < 768
      }
    },
    methods: {
      onClickTabs(step) {
        this.$router.push({query: {step: step} });
      }
    }
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
